export class GetUserErrorAction {
  public static readonly type = '[User] GetUserErrorAction';
  constructor(public readonly error: Error) {}
}
